import { HGroup } from '../area/HGroup';
import { Global } from '../utilities/global';
import * as _ from 'lodash';
import { Sol50OnRoof } from '../mountsys/Sol50OnRoof';
import { Sol50 } from '../mountsys/Sol50';
import { SC_Input } from '../input/SC_Input';
import Konva from 'konva';
import { DrawRoofForPanel } from './drawRoofForPanel';
import { VGroup } from '../area/VGroup';
import { RoofShape } from '../roof/RoofShape';
import { getCanvasLine, getCanvasRect } from '../konva/getCanvas';
import { GetArea } from "./areaConvertion";

export class layoutCheckIntegrated {
    //in cm
    public static nRandLeftRight: number = 45;
    //in cm
    public static nRandLeft: number = 22.5;
    //in cm
    public static nRandRight: number = 22.5;
    //in cm
    public static nRandTop: number = 30;
    //in cm
    public static nRandBottom: number = 30;
    //in cm
    public static nGroupDistance: number = 20;

    static nGroupDistanceH: number = Sol50.nHorizontalAbstand + Global.nModAbstTol;
    static nGroupDistanceV: number = Sol50.nVertikalAbstand + Global.nModAbstTol;
    static aVGroups: any = [];
    static groups: any;

    static removeAllEllipse() {
        var obj: any = DrawRoofForPanel.layerPanel.find(".ellipseError");
        if (obj && obj.length > 0)
            obj.forEach((item: any) => {
                item.destroy();
            });
        DrawRoofForPanel.layerPanel.draw();
    }
    static checkGroups() {
        this.removeAllEllipse();
        this.getGroups();
        this.check_aVGroups();
    }
    static getGroups() {
        var groups: any[] = []
        var hGroups = [...Global.panelRows];
        hGroups = _.sortBy(hGroups, 'x');
        // console.log(hGroups);
        const g: any[] = [];
        const listOfIndexes: any = [];
        let panelWidth = (SC_Input.nModWidth / 10);
        let panelHeight = (SC_Input.nModHeight / 10);
        let w: number, h: number;
        hGroups.forEach((item, i) => {
            if (listOfIndexes.indexOf(i) == -1) {
                const a: any = [];
                a.push(item)
                hGroups.forEach((itemj, j) => {
                    if (i != j) {
                        if (item.panelCount == itemj.panelCount && item.x == itemj.x && item.portrait == itemj.portrait) {
                            // itemj.portrait;
                            if (itemj.portrait) {
                                w = panelWidth
                                h = panelHeight;
                            } else {
                                w = panelHeight;
                                h = panelWidth;
                            }
                            const diff = (itemj.y - a[a.length - 1].y - h);
                            a.push(itemj);
                            listOfIndexes.push(j);
                        }
                    }
                });
                g.push(a);
            }
        })
        // 
        g.forEach((inner: any[]) => {
            let isInit = true;
            let b: any[] = []
            inner.forEach((t, ine: any) => {
                if (!isInit) {
                    if (Math.abs(h + Sol50.nVertikalAbstand - (t.y - inner[ine - 1].y)) < Sol50.nVertikalAbstand) {
                        b.push(t)
                    } else {
                        if (b.length > 0)
                            groups.push(new GetArea(b));
                        b = [];
                        b.push(t);
                        isInit = true;
                    }
                } else {
                    b.push(t);
                    isInit = false;
                }
            });
            groups.push(new GetArea(b));
        })
        this.groups = groups;
    }


    static check_aVGroups(): boolean {
        var vgroupTmp1: VGroup;
        var i: number, j: number;
        var iLen: number;
        var bRet: boolean;
        iLen = this.groups.length;
        // iLen = this.aVGroups.length;
        bRet = true;
        if (iLen == 0) return bRet;
        //aVGroups was sorted by x
        for (i = 0; i < iLen; i++) {
            j = i + 1;
            if (j < iLen) {
                bRet = this.check_VGroup(this.groups[i], j, iLen);
                if (!bRet) break;
            }
        }
        return bRet;
    }
    //check aVGroups
    private static check_VGroup(vgroupTmp1: VGroup, iStart: number, iLen: number): boolean {
        var nTop1: number, nBottom1: number;
        var nLeft1: number, nRight1: number;
        var nTop2: number, nBottom2: number;
        var nLeft2: number, nRight2: number;
        var vgroupTmp2: VGroup;
        var nHTmp: number, nVTmp: number;
        var nYDistance: number, nXDistance: number;
        nTop1 = vgroupTmp1.y - this.nRandTop;
        nBottom1 = vgroupTmp1.y + vgroupTmp1.height;
        nLeft1 = vgroupTmp1.x - this.nRandLeft;
        nRight1 = vgroupTmp1.x + vgroupTmp1.width + this.nRandRight;
        for (; iStart < iLen; iStart++) {
            vgroupTmp2 = (this.groups[iStart]);
            if (vgroupTmp2.x > vgroupTmp1.x) {
                // console.log(vgroupTmp2.x - vgroupTmp1.x + vgroupTmp1.width)
            } else {
                // console.log(vgroupTmp2.x + vgroupTmp2.width - vgroupTmp1.x)
            }
            nTop2 = vgroupTmp2.y - this.nRandTop;
            nBottom2 = vgroupTmp2.y + vgroupTmp2.height;
            nLeft2 = vgroupTmp2.x - this.nRandLeft;
            nRight2 = vgroupTmp2.x + vgroupTmp2.width + this.nRandRight;
            if (nLeft2 < nRight1) {
                //y distance check
                if (nTop2 > nTop1) {
                    if (nTop2 - nBottom1 < 0) {
                        this.drawLine(vgroupTmp1, "#ff0000");
                        this.drawLine(vgroupTmp2, "#ff5500");
                        return false;
                    }
                } else {
                    if (nTop1 - nBottom2 < 0) {
                        this.drawLine(vgroupTmp1, "#ff0000");
                        this.drawLine(vgroupTmp2, "#ff5500");
                        return false;
                    }
                }
            } else {
                break;
            }

        }
        return true;
    }

    static drawLine(style: any, color: string) {
        const x1 = style.x;
        const y1 = style.y;
        const x2 = style.x + style.width;
        const y2 = style.y;
        const x3 = style.x + style.width;
        const y3 = style.y + style.height;
        const x4 = style.x;
        const y4 = style.y + style.height;
        const x5 = style.x;
        const y5 = style.y;

        const line = getCanvasLine({
            points: [x1, y1, x2, y2, x3, y3, x4, y4, x5, y5],
            stroke: color,
            strokeWidth: 5,
            name: "ellipseError"
        });
        DrawRoofForPanel.layerPanel.add(line);
        line.draw();
    }
}